

import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

import './flex.js'

export default {
name: 'app',
components: {
Tabbar,
TabbarItem,
},
created(){
this.setSourceUrl();
},
methods:{
go() {

window.location.href="/m/learn/product/index.html";
},
setSourceUrl() {
var cookie = this.$cookies.get("sourceUrl");
if(cookie==null){
var sourceUrl = window.document.referrer;
this.$cookies.set("sourceUrl", sourceUrl,"0")
}
}

},
watch: {//监听某个变量改变后执行炒作
"$route.path": {
handler(path) {


if (path === "/" || path === "/app/saas/index" || path === "/m/learn/learnIndex.html"|| path === "/activity" || path === "/user/index" || path==="/newindex" || path ==="/mall/index"
|| path === "/developer/index" || path === "/app/cooperation/index" || path === "/consult/consultlist"|| path === "/consult/consultdetail"
|| path === "/consult/sharelist"|| path === "/consult/sharedetail") {
this.is_tabber = true
} else {
this.is_tabber = false
}


if(path.indexOf("user")>=0){
var token = this.getToken() ;
if(token == null || token == ""){
this.$router.replace("/auth/login")
}
}

},
immediate: true
}
},
data() {
return {
is_tabber: true,
path: this.$route.path,
transitionName: '',
isRouterAlive:false,
}
}
}



// WEBPACK FOOTER //
// ./src/App.vue